import { useMutation } from 'react-query'
import { useLocation } from 'react-router'
import { toast } from 'react-toastify'
import { postGatewayPayment } from 'services/easyPay'
import posthog from 'posthog-js'

export default function useSetGatewayPayment() {
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGatewayPaymentPayload) => {
            return postGatewayPayment(payload)
        },
        onSuccess: (result, variables) => {
            posthog.capture('payment_gateway_redirect', {
                flow_type: 'gateway_payment',
                gateway: variables?.gateway?.uniqueCode,
                use_wallet: (variables as any)?.use_wallet,
                items_count: variables?.paymentItems?.length,
                transaction_pk: (result as any)?.pk,
            })
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'group-all-payment',
                    data: state.toBePaidTransactions,
                    //@ts-ignore
                    pk: result?.pk,
                    //@ts-ignore
                    gateway: result?.gateway,
                })
            )
            //@ts-ignore
            window.location.replace(result?.payment_link)
            console.log('result : ', result)
        },
        onError: (error: any) => {
            // Surface the backend's specific message (e.g. a gateway that is not
            // enabled for this box returns {"error": "..."}). Fall back to the
            // generic toast when the body has no string message (e.g. serializer
            // errors come back as an object, or network errors have no body).
            const backendMessage = error?.response?.data?.error
            posthog.capture('payment_initiate_failed', {
                flow_type: 'gateway_payment',
                error_message:
                    typeof backendMessage === 'string' ? backendMessage : null,
                status: error?.response?.status,
            })
            toast.error(
                typeof backendMessage === 'string' && backendMessage
                    ? backendMessage
                    : 'مشکلی پیش آمده!'
            )
        },
    })
    return { mutate, isLoading }
}
